var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"container"},[_c('adminNav'),_c('el-container',[_c('el-header',{staticClass:"headerBtn"},[_c('adminHeader')],1),_c('router-view',{staticClass:"main__body"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }